//deps
import React, { memo, useEffect, useState, useRef } from "react";
import { CSSTransition } from "react-transition-group";

// internal deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { CROSS_SELL_TEST_IDS } from "@swiggy-private/cart-test-ids";

//widgets
import { CrossSellM2TickIcon } from "@cart-ui/widgets/cross-sell-m2-tick-icon";

// styles
import { Container } from "./CrossSellM2ItemsAdded.style";

// constants
import {
    CROSS_SELL_M2_ALL_ITEMS_ADDED,
    CROSS_SELL_M2_ALL_ITEMS_ADDED_ANIMATION_TRIGGER_TIMER,
    CROSS_SELL_M2_ALL_ITEMS_ADDED_TIMER,
    TEXTS,
} from "@cart-ui/constants";

// styles
import styles from "./styles.scss";

const CrossSellM2ItemsAdded = () => {
    const [triggerAnimation, setTriggerAnimation] = useState(true);
    const nodeRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            setTriggerAnimation(false);
            if (!sessionStorage.getItem(CROSS_SELL_M2_ALL_ITEMS_ADDED)) {
                sessionStorage.setItem(CROSS_SELL_M2_ALL_ITEMS_ADDED, "true");
            }
        }, CROSS_SELL_M2_ALL_ITEMS_ADDED_ANIMATION_TRIGGER_TIMER);

        return () => clearTimeout(timer);
    }, []);

    if (!sessionStorage.getItem(CROSS_SELL_M2_ALL_ITEMS_ADDED)) {
        return (
            <CSSTransition
                in={triggerAnimation}
                nodeRef={nodeRef}
                timeout={CROSS_SELL_M2_ALL_ITEMS_ADDED_TIMER}
                classNames={{
                    exit: styles.transitionExit,
                    exitActive: styles.transitionExitActive,
                }}
                unmountOnExit
            >
                <Container data-testid={CROSS_SELL_TEST_IDS.ALL_ITEMS_ADDED_CONTAINER} ref={nodeRef}>
                    <CrossSellM2TickIcon />
                    <Text variant="V2.body2.neutral.medium" color="text_High_Emphasis">
                        {TEXTS.ADDED_ALL_ITEMS}
                    </Text>
                </Container>
            </CSSTransition>
        );
    }

    return null;
};

export default memo(CrossSellM2ItemsAdded);
